import { useEffect } from "react";

export default function usePageTitle(suffix) {
  useEffect(() => {
    document.title = suffix
      ? `${suffix} - LinkedScope`
      : "LinkedScope";
  }, [suffix]);
}